import { useEffect, useState } from "react";

export default function useLocalStorageState(key, initialValue, { ttlMs } = {}) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return initialValue;

      const parsed = JSON.parse(raw);

      // TTL support: { value, savedAt }
      if (ttlMs && parsed && typeof parsed === "object" && "savedAt" in parsed && "value" in parsed) {
        const age = Date.now() - Number(parsed.savedAt || 0);
        if (age > ttlMs) return initialValue;
        return parsed.value;
      }

      return parsed;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      const payload = ttlMs ? { value, savedAt: Date.now() } : value;
      localStorage.setItem(key, JSON.stringify(payload));
    } catch {
      // ignore quota / private mode
    }
  }, [key, value, ttlMs]);

  return [value, setValue];
}
